<template>
  <collapse-default id="declarante_testemunha_collapse"
                    :condition="(partes && partes.length)">
    <template v-slot:header>
      Partes {{ (!partes.length) ? '- Não informado' : '' }}
    </template>

    <template v-slot:content>
      <div v-for="(parte, index) in listPartes"
           :key="`${index}-parte`"
           class="resumo-show_header--shadow mt-3">
        <div class="resumo-show_header--blue">
          {{ parte.pessoa.nome || 'Não informado' }}
        </div>
        <div class="pl-3 pb-1 row">
          <div class="col">
            <div class="row">
              <div class="col">
                <label class="resumo-show_header--label">CPF</label>
                <div
                  class="resumo-show_header--sublabel">
                  {{ parte.pessoa.cpf || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Profissão</label>
                <div
                  class="resumo-show_header--sublabel">
                  {{ (parte.pessoa && parte.pessoa.ocupacao_declarada || 'Não informado') | firstCapitalize }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Nacionalidade</label>
                <div
                  v-if="parte.pessoa.nacionalidade"
                  class="resumo-show_header--sublabel">
                  <span v-if="parte.pessoa.sexo == 'FEMININO'">{{ parte.pessoa.nacionalidade.nome_feminino | firstCapitalize }}</span>
                  <span v-else>{{ parte.pessoa.nacionalidade.nome_masculino | firstCapitalize }}</span>
                </div>
                <div v-else
                     class="resumo-show_header--sublabel">
                  {{ parte.pessoa.nacionalidade && parte.pessoa.nacionalidade.nome || 'Não informado' }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Estado Civil</label>
                <div
                  class="resumo-show_header--sublabel">
                  {{ parte.pessoa.estado_civil | estadoCivil }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">RG</label>
                <div class="resumo-show_header--sublabel">
                  {{ getDocument(parte.pessoa.documentos, "RG") }}
                </div>
              </div>
              <div class="col">
                <label class="resumo-show_header--label">Endereço Cadastrado</label>
                <div
                  class="resumo-show_header--sublabel">
                  {{ (parte.pessoa.endereco && ( parte.pessoa.endereco.logradouro || parte.pessoa.endereco.ibge)) ? 'Sim' : 'Não' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </collapse-default>
</template>

<script>
  import CollapseDefault from "./CollapseDefault"

  export default {
    name: "PartesCollapse",
    components: {
      CollapseDefault
    },
    props: {
      genitores: Array,
      partes: Array,
    },
    computed: {
      listPartes () {
        let lista = this.genitores

        if (!this.partes.length) return []

        return this.partes.filter((value, ind) => {
          let checkGenitor = lista.every(e => e.genitor_pessoa_id !== value.pessoa_id)

          if (checkGenitor) { return value }
        })
      }
    },
    methods: {
      getDocument (documents, type) {
        const document = documents.find( (document) =>  document.tipo_documento == type)
        return document && document.numero || 'Não informado'
      }
    }
  }
</script>

<style scoped>

</style>
